import { render } from "./BioIntelligentPart3.vue?vue&type=template&id=834c1f90&scoped=true"
import script from "./BioIntelligentPart3.vue?vue&type=script&lang=js"
export * from "./BioIntelligentPart3.vue?vue&type=script&lang=js"

import "./BioIntelligentPart3.vue?vue&type=style&index=0&id=834c1f90&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-834c1f90"]])

export default __exports__